function Error404() {
  return (
    <div className="text-center mt-10">
      <h1 className="text-4xl">404</h1>
      <p className="mt-10">Oops, it seems that this page does not exist.</p>
    </div>
  );
}

export default Error404;
